import { Check } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { scrollToSection } from "./data";

const CHECKLIST = [
  "20+ years of painting experience",
  "Residential & commercial projects",
  "Professional cabinet refinishing",
  "Interior & exterior painting",
  "Fence & deck staining",
  "Free, no-pressure estimates",
];

const About = () => (
  <section id="about" data-testid="about-section" className="grain relative overflow-hidden bg-navy py-24 sm:py-32">
    <div className="bg-grid-gold absolute inset-0" aria-hidden="true" />
    <div className="absolute -right-32 top-0 h-96 w-96 rounded-full bg-gold/10 blur-[120px]" aria-hidden="true" />

    <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
      <Reveal className="relative">
        <div className="relative" data-testid="about-image-frame">
          <div aria-hidden="true" className="absolute -inset-0 translate-x-4 translate-y-4 rounded-3xl border border-gold/35" />
          <img
            src="/assets/gallery_island.webp"
            alt="Custom navy kitchen island with a factory-smooth painted finish by Teo's Painting LLC"
            className="relative aspect-[4/5] w-full rounded-3xl object-cover shadow-2xl"
            loading="lazy"
          />
          <div className="absolute -bottom-7 left-6 rounded-2xl bg-gold px-7 py-4 text-navy shadow-[0_20px_45px_-15px_rgba(212,175,55,0.6)] sm:-left-7">
            <p className="font-display text-4xl font-extrabold leading-none">20+</p>
            <p className="mt-1 text-[10px] font-extrabold tracking-[0.22em]">YEARS OF EXPERIENCE</p>
          </div>
        </div>
      </Reveal>

      <div>
        <SectionHead num="02" eyebrow="About Teo's Painting" title="Experience You Can See." dark testid="about-head" />
        <Reveal delay={0.15}>
          <p className="mt-6 text-base leading-relaxed text-white/70 sm:text-lg">
            Teo's Painting LLC has spent over two decades perfecting one thing: a flawless finish.
            We believe a great paint job is built long before the first coat — in the preparation,
            the protection of your home, and the details most contractors skip.
          </p>
          <p className="mt-4 text-base leading-relaxed text-white/70 sm:text-lg">
            From quality preparation and professional finishes to meticulous attention to detail,
            every project is measured by one standard — your complete satisfaction.
          </p>
        </Reveal>

        <ul className="mt-9 grid gap-x-8 gap-y-4 sm:grid-cols-2" data-testid="about-checklist">
          {CHECKLIST.map((item, i) => (
            <Reveal key={item} delay={0.1 + i * 0.05}>
              <li className="flex items-start gap-3 text-sm text-white/85 sm:text-base">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold">
                  <Check size={13} strokeWidth={3} />
                </span>
                {item}
              </li>
            </Reveal>
          ))}
        </ul>

        <Reveal delay={0.35}>
          <button
            data-testid="about-estimate-cta"
            onClick={() => scrollToSection("#contact")}
            className="mt-10 rounded-full bg-gold px-8 py-4 text-[13px] font-extrabold tracking-[0.14em] text-navy transition-[background-color,transform] duration-200 hover:scale-[1.04] hover:bg-gold-light"
          >
            GET YOUR FREE ESTIMATE
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
